import { BookOpen, History, ShieldCheck, Workflow } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Automations — rules that do the follow-ups, reminders and handovers
 * (PRD §8 Item 13, US-13.1 … US-13.6).
 *
 * `/automations/:id` is fixed by ENTITY_ROUTES: search results and the
 * "your rule is failing" notification link there. `/automations/new` is the
 * same page with nothing loaded.
 */
export default defineFeature({
  key: "automations",
  title: "Automations",
  entities: ["automation"],
  routes: [
    { path: "automations", lazy: () => import("./page") },
    { path: "automations/:id", lazy: () => import("./rule") },
  ],
  nav: [
    {
      label: "Automations",
      to: "/automations",
      icon: Workflow,
      group: "workspace",
      order: 10,
      permission: "automations:manage",
      description: "Rules that do the follow-ups for you",
    },
  ],
  quickCreate: [
    {
      key: "automations",
      label: "Automation",
      icon: Workflow,
      to: "/automations?new=1",
      permission: "automations:manage",
      description: "When this happens, do that",
    },
  ],
  commands: [
    { key: "automations.recipes", label: "Automation recipes", icon: BookOpen, to: "/automations?tab=recipes", group: "actions", permission: "automations:manage", keywords: ["template", "workflow", "rule"] },
    { key: "automations.runs", label: "Automation run history", icon: History, to: "/automations?tab=runs", group: "navigate", permission: "automations:manage", keywords: ["log", "failed", "retry"] },
    {
      key: "automations.approve",
      label: "Approve waiting automation runs",
      icon: ShieldCheck,
      to: "/automations?tab=runs&status=needs_attention",
      group: "actions",
      permission: "automations:manage",
      keywords: ["client-facing", "pending", "approval"],
    },
  ],
});
